export default "/images/032f8997cf2bd64ddeb022ed3e513479.avif";